import { parseISO } from 'date-fns';
import { FALLBACK_AUTHOR, mapUser } from '../../User';
import { userToAuthor } from '../../../api/helpers';
import { RExchangeComment, RExchangeReply } from '../remote/exchangeComment';
import { ExchangeComment, ExchangeReply } from '../domain/exchangeComment';

export const mapExchangeComments = (comments: RExchangeComment[]) => {

    const mapReply = (reply: RExchangeReply): ExchangeReply => {
        const replyAuthor = reply.author ? mapUser(reply.author) : null;

        return {
            id: reply.documentId,
            content: reply.content,
            createdAt: parseISO(reply.createdAt),
            updatedAt: parseISO(reply.updatedAt),
            author: replyAuthor ? userToAuthor(replyAuthor) : FALLBACK_AUTHOR
        };
    };

    const mapComment = (comment: RExchangeComment): ExchangeComment => {
        const commentAuthor = comment.author ? mapUser(comment.author) : null;

        return {
            id: comment.documentId,
            title: comment.title,
            content: comment.content,
            createdAt: parseISO(comment.createdAt),
            updatedAt: parseISO(comment.updatedAt),
            author: commentAuthor ? userToAuthor(commentAuthor) : FALLBACK_AUTHOR,
            replies: comment.replies.map(mapReply)
        };
    };

    return comments.map(mapComment);
};
